import { css } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import type { EnvironmentResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { EnvironmentMultiSelect } from "~/components/MultiSelect/EnvironmentMultiSelect";
import type { ScopedCommonTemplatesScopeChangeTracker, ScopedCommonTemplatesScopeKey } from "./useScopedCommonTemplatesScopeChangeTracker";
interface ScopedCommonTemplateScopeEditProps {
    environments: EnvironmentResource[];
    scopeChangeTracker: ScopedCommonTemplatesScopeChangeTracker;
    scopeKey: ScopedCommonTemplatesScopeKey;
    initialEnvironmentScope: string[];
}
export default ({ environments, scopeChangeTracker, scopeKey, initialEnvironmentScope }: ScopedCommonTemplateScopeEditProps) => {
    const isScopePropertyValueUnchanged = (initialEnvironmentScope: string[], scope: string[] | undefined): boolean => {
        if (!initialEnvironmentScope || !scope) {
            return initialEnvironmentScope === scope;
        }
        if (initialEnvironmentScope.length !== scope.length) {
            return false;
        }
        return initialEnvironmentScope.every((s, i) => s === scope[i]);
    };
    const handleChange = (newScope: string[]) => {
        if (isScopePropertyValueUnchanged(initialEnvironmentScope, newScope)) {
            if (scopeChangeTracker.has(scopeKey)) {
                scopeChangeTracker.remove(scopeKey);
            }
        }
        else {
            scopeChangeTracker.set(scopeKey, newScope);
        }
    };
    const value = scopeChangeTracker.has(scopeKey) ? scopeChangeTracker.get(scopeKey) || [] : initialEnvironmentScope;
    return (<div className={cellStyles.container}>
            <EnvironmentMultiSelect environments={environments} onChange={(environmentIds) => {
            handleChange(environmentIds);
        }} value={value}/>
        </div>);
};
const cellStyles = {
    container: css({
        marginLeft: space[8],
        marginRight: space[8],
    }),
};
